/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Tlm_1Inputs */

const en_svc_messaging_bots_tlm_1 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`payments`)
};

const ar_svc_messaging_bots_tlm_1 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المدفوعات`)
};

const bn_svc_messaging_bots_tlm_1 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`payments`)
};

const de_svc_messaging_bots_tlm_1 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlungen`)
};

const es_svc_messaging_bots_tlm_1 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pagos`)
};

const fr_svc_messaging_bots_tlm_1 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`paiements`)
};

const pt_svc_messaging_bots_tlm_1 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pagamentos`)
};

const zh_svc_messaging_bots_tlm_1 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付款`)
};

const tr_svc_messaging_bots_tlm_1 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ödemeler`)
};

const ru_svc_messaging_bots_tlm_1 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`платежей`)
};

const pl_svc_messaging_bots_tlm_1 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`płatności`)
};

/**
* | output |
* | --- |
* | "payments" |
*
* @param {Svc_Messaging_Bots_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_tlm_1 = /** @type {((inputs?: Svc_Messaging_Bots_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_tlm_1(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_tlm_1(inputs)
	if (locale === "de") return de_svc_messaging_bots_tlm_1(inputs)
	if (locale === "es") return es_svc_messaging_bots_tlm_1(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_tlm_1(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_tlm_1(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_tlm_1(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_tlm_1(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_tlm_1(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_tlm_1(inputs)
	return en_svc_messaging_bots_tlm_1(inputs)
});
export { svc_messaging_bots_tlm_1 as "svc_messaging-bots_tlm_1" }